import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AviaryV2ShareRedirectPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const leadId = String(searchParams.get('leadId') || '').trim();
    const campaign = String(searchParams.get('campaign') || 'all').trim() || 'all';
    const articleSlug = String(searchParams.get('articleSlug') || '').trim();

    if (!leadId) {
      navigate('/v2/board', { replace: true });
      return;
    }

    const next = new URLSearchParams();
    next.set('queue', 'connected');
    next.set('campaign', campaign);
    if (articleSlug) next.set('articleSlug', articleSlug);
    navigate(`/v2/leads/${encodeURIComponent(leadId)}?${next.toString()}`, { replace: true });
  }, [navigate, searchParams]);

  return null;
}
